import React, { useState, useEffect } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import BackToTop from "../../components/backToTop/BackToTop";
import "./../privacyPolicy/PrivacyPolicy.css"; // reuse same styling

const CodeOfConduct = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    useEffect(() => {
      const filters = document.querySelector(".filters-row");
  
      const handleScroll = () => {
        if (!filters) return;
  
        const offset = filters.getBoundingClientRect().top;
  
        if (offset <= 80) {
          filters.classList.add("stuck");
        } else {
          filters.classList.remove("stuck");
        }
      };
  
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }, []);
  
    useEffect(() => {
      // Scroll to top smoothly when the component mounts / route changes
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant", // or "smooth" if you prefer a gentle scroll
      });
    }, []);

    const handleSectionClick = () => {
    setIsSidebarOpen(false);
  };


  return (
    <>
      <Header
        isMenuOpen={isMenuOpen}
        onMenuToggle={() => setIsMenuOpen(!isMenuOpen)}
      />

      {/* ===== HERO ===== */}
      <section className="legal-hero">
        <div className="legal-container">
          <h1>TUTORSLINKS Code of Conduct</h1>
        </div>
      </section>

      {/* ===== CONTENT ===== */}
      <section className="legal-content-section">
        <div className="legal-container legal-grid">
          {/* ===== MOBILE SIDEBAR TOGGLE ===== */}
          <button
            className="sidebar-toggle"
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          >
            {isSidebarOpen ? "Close Sections" : "View Sections"}
          </button>
          {isSidebarOpen && (
            <div
              className="sidebar-overlay"
              onClick={() => setIsSidebarOpen(false)}
            />
          )}
          {/* ===== SIDEBAR ===== */}
          <aside className={`legal-sidebar ${isSidebarOpen ? "open" : ""}`}>
            <a href="#core-values" onClick={handleSectionClick}>Core Values</a>
            <a href="#tutors" onClick={handleSectionClick}>Tutors & Centres</a>
            <a href="#students" onClick={handleSectionClick}>Students</a>
            <a href="#all-users" onClick={handleSectionClick}>All Users</a>
            <a href="#confidentiality" onClick={handleSectionClick}>Confidentiality and Data Privacy</a>
            <a href="#reporting" onClick={handleSectionClick}>Reporting Violations</a>
            <a href="#disciplinary" onClick={handleSectionClick}>Disciplinary Actions</a>
            <a href="#improvement" onClick={handleSectionClick}>Continuous Improvement</a>
            <a href="#contact" onClick={handleSectionClick}>Contact Us</a>
          </aside>

          {/* ===== MAIN CONTENT ===== */}
          <div className="legal-content">
            <p className="last-updated">Last Updated: 28 February 2026</p>

            <p>
              TutorsLinks is committed to maintaining a safe, respectful, and
              professional learning community for everyone. <br />
              By registering as a <strong>tutor</strong>,{" "}
              <strong>student</strong>, or <strong>training centre</strong>, you
              agree to follow this Code of Conduct.
            </p>

            {/* 1 */}
            <section id="core-values">
              <h2>1. Core Values</h2>
              <p>All users of TutorsLinks are expected to uphold: </p>
              <ul>
                <li>
                  <strong>Respect</strong> – Treat others with courtesy,
                  regardless of age, gender, background, or beliefs.
                </li>
                <li>
                  <strong>Integrity</strong> – Be honest and transparent in all
                  interactions.
                </li>
                <li>
                  <strong>Professionalism</strong> – Communicate clearly and
                  deliver on commitments.
                </li>
                <li>
                  <strong>Accountability</strong> – Take responsibility for your
                  actions on the platform.
                </li>
                <li>
                  <strong>Safety</strong> – Prioritize the well-being and
                  security of all users.
                </li>
              </ul>
            </section>

            {/* A */}
            <section id="tutors">
              <h2>A. For Tutors & Training Centres</h2>

              <h3>1. Professional Conduct</h3>
              <ul>
                <li>
                  Provide accurate and truthful information about your
                  qualifications, programs, and pricing.{" "}
                </li>
                <li>Deliver lessons as scheduled and maintain punctuality.</li>
                <li>
                  Avoid cancelling or rescheduling repeatedly without valid
                  reasons.{" "}
                </li>
                <li>
                  Maintain a positive and respectful attitude towards students
                  at all times.{" "}
                </li>
                <li>
                  Do not engage in any form of discrimination, harassment, or
                  abuse.
                </li>
              </ul>

              <h3>2. Content & Teaching Standards</h3>
              <ul>
                <li>
                  Ensure learning materials are original or properly
                  licensed.{" "}
                </li>
                <li>
                  Keep lessons appropriate for all audiences — no offensive,
                  illegal, or adult content.{" "}
                </li>
                <li>
                  Provide value that aligns with what was advertised in your
                  course description
                </li>
                <li>
                  Maintain confidentiality of student information and data.{" "}
                </li>
              </ul>

              <h3>3. Communication & Boundaries</h3>
              <ul>
                <li>
                  Use only TutorsLinks’ official chat or communication tools for
                  lessons and inquiries.{" "}
                </li>
                <li>
                  Avoid requesting personal contact or payment outside the
                  platform if payment methods are already available on the
                  platform.
                </li>
                <li>
                  Do not share or solicit inappropriate content or messages.
                </li>
                <li>
                  Report suspicious behavior to{" "}
                  <strong>support@tutorslinks.com</strong>.
                </li>
              </ul>

              <h3>4. Verification & Compliance</h3>
              <ul>
                <li>
                  Complete your profile and verification requirements honestly.
                </li>
                <li>
                  Upload valid certificates, IDs, or credentials where required.
                </li>
                <li>
                  Comply with all applicable educational, safety, and tax
                  regulations.
                </li>
              </ul>
            </section>

            {/* B */}
            <section id="students">
              <h2>B. For Students</h2>

              <h3>1. Respect & Engagement</h3>
              <ul>
                <li>
                  Attend scheduled sessions on time and communicate early if you
                  must cancel.{" "}
                </li>
                <li>
                  Treat tutors and other learners with respect and courtesy.
                </li>
                <li>
                  Provide constructive feedback, not abusive or false
                  reviews.{" "}
                </li>
                <li>
                  Avoid using disrespectful, discriminatory, or offensive
                  language.{" "}
                </li>
              </ul>

              <h3>2. Payment & Platform Use</h3>
              <ul>
                <li>
                  Make all payments through the official TutorsLinks platform
                  only.{" "}
                </li>
                <li>
                  Do not attempt to bypass TutorsLinks for private arrangements
                  or payments.{" "}
                </li>
                <li>
                  Respect tutors’ time and policies on cancellations or refunds.
                </li>
              </ul>

              <h3>3. Learning Integrity</h3>
              <ul>
                <li>
                  Do not engage in cheating, plagiarism, or misrepresentation
                  during classes or assessments.{" "}
                </li>
                <li>
                  Do not share paid materials publicly or with non-registered
                  users.
                </li>
                <li>
                  Follow course rules as set by your tutor or training
                  centre.{" "}
                </li>
              </ul>
            </section>

            {/* C */}
            <section id="all-users">
              <h2>C. For All Users</h2>
              <p>
                <strong>1. Zero Tolerance for Misconduct</strong>
              </p>
              <p>TutorsLinks has zero tolerance for: </p>
              <ul>
                <li>
                  Sexual harassment, discrimination, bullying, or intimidation.
                </li>
                <li>
                  Fraudulent activities, impersonation, or sharing of false
                  information.
                </li>
                <li>
                  Unlawful activities including hacking, hate speech, or
                  exploitation.
                </li>
              </ul>
              <p>
                Any confirmed misconduct may result in immediate suspension or
                permanent account termination.{" "}
              </p>
            </section>
            {/* Confidentiality */}
            <section id="confidentiality">
              <p>
                <strong>2. Confidentiality and Data Privacy</strong>
              </p>
              <p>
                All users must protect the privacy and data of others. <br />
                Do not share another user’s personal or contact information
                without consent.
              </p>
            </section>
            {/* Reporting */}
            <section id="reporting">
              <p>
                <strong>3. Reporting Violations. </strong>
              </p>
              <p>If you experience or witness any violation of this Code::</p>
              <ul>
                <li>
                  Report immediately to <strong>support@tutorslinks.com</strong>.
                </li>
                <li>
                  Provide clear details and evidence where possible. <br />
                  TutorsLinks will review all reports confidentially and take
                  appropriate action.
                </li>
              </ul>
            </section>

            {/* Disciplinary */}
            <section id="disciplinary">
              <p>
                <strong>3. Disciplinary Actions. </strong>
              </p>
              <p>
                Depending on the severity of the offense, actions may include:
              </p>
              <ul>
                <li>Warning or temporary suspension.</li>
                <li>Account removal or permanent ban.</li>
                <li>Legal action where required by law.</li>
              </ul>
            </section>

            {/* Improvement */}
            <section id="improvement">
              <p>
                <strong>4. Continuous Improvement. </strong>
              </p>
              <p>
                TutorsLinks reserves the right to update this Code to ensure a
                positive and safe learning community. <br />
                Updates will be published on the website with the latest
                revision date.
              </p>
            </section>

            {/* Contact */}
            <section id="contact">
              <p>
                <strong>5. Contact Us</strong>
              </p>
              <p>
                For concerns or support:
                <br />
                {/* </p>
              <p> */}
                <strong>TutorsLinks (Efiko Edutech Ltd.)</strong>
                <br />
                Email: <strong>support@tutorslinks.com</strong>
              </p>
            </section>
          </div>
        </div>
      </section>

      {/* TRUST */}
      <section className="trust-section">
        <div className="trust-container">
          <div className="shield-icon">
            <img src="/images/shield-icon.png" alt="Trust" />
          </div>
          <h2>Your Trust Is Our Priority</h2>
          <p>
            Our Tutors are committed to the highest standard of student learning,
            safety, privacy and data protection. Verified tutors and training centres display a verification badge.
          </p>
          <a href="" className="trust-btn">
            Get Started →
          </a>
        </div>
      </section>

      <Footer />
      <BackToTop />
    </>
  );
};

export default CodeOfConduct;
